import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './LinkedInIcon.module.scss';

const LinkedInIcon: FC<LinkedInIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.linkedInIcon, className]}
      viewBox="0 0 44 44"
      {...rest}
    >
      <circle
        data-name="Ellipse 209"
        cx="22"
        cy="22"
        r="22"
        style={{ fill: '#fff' }}
      />
      <g data-name="linkedin">
        <path
          data-name="Tracé 4774"
          d="M185.9 16.1a2.2 2.2 0 1 1-2.2-2.2 2.2 2.2 0 0 1 2.2 2.2"
          transform="translate(-168 -1.002)"
          style={{ fill: '#003da5' }}
        />
        <path
          data-name="Rectangle 1634"
          transform="translate(13.8 18.598)"
          style={{ fill: '#003da5' }}
          d="M0 0h3.9v11.28H0z"
        />
        <path
          data-name="Tracé 4775"
          d="M194.9 19.3a4 4 0 0 0-3.5 1.9v-1.6h-3.9v11.3h3.9v-6.7a2.3 2.3 0 0 1 2.1-1.9 2 2 0 0 1 1.9 2.1v6.4h3.9v-6.3c0-3.1-1.4-5.2-4.4-5.2"
          transform="translate(-168 -1.002)"
          style={{ fill: '#003da5' }}
        />
      </g>
    </Svg>
  );
};

type LinkedInIconProps = {
  className?: string;
};
export default LinkedInIcon;
